import { Resource } from 'i18next';

import { AppLanguage } from '@/shared/constants/app-language.constant';

export const generateI18nResources = () => {
	const ns = [
		'aggregade',
		'agreementsSettings',
		'cockpit',
		'common',
		'dashboard',
		'helmet',
		'helmetPlant',
		'historical',
		'history',
		'login',
		'management',
		'map',
		'multy',
		'notifications',
		'oilAnalysis',
		'overview',
		'plant',
		'profile',
		'realtime',
		'tables',
		'users',
		'yachts',
	];

	const supportedLngs = Object.values(AppLanguage);

	const localeModules = import.meta.glob('../../../../public/locales/*/*.json', { eager: true });

	const resources = ns.reduce((acc: Resource, n) => {
		supportedLngs.forEach((lng) => {
			const key = Object.keys(localeModules).find((p) => p.endsWith(`/public/locales/${lng}/${n}.json`));

			if (!key) {
				return acc;
			}

			const moduleValue = localeModules[key] as unknown as { default?: unknown };

			if (!acc[lng]) acc[lng] = {};
			acc[lng] = {
				...acc[lng],
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				[n]: (moduleValue as any).default ?? moduleValue,
			};
		});
		return acc;
	}, {});

	return { supportedLngs, resources, ns };
};
